import { render, staticRenderFns } from "./EnterName.vue?vue&type=template&id=568e946b&scoped=true"
import script from "./EnterName.vue?vue&type=script&lang=js"
export * from "./EnterName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568e946b",
  null
  
)

export default component.exports